let store = {
  set (key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  get (key) {
    return JSON.parse(localStorage.getItem(key)) || {}
  },
  removeItem (key) {
    return localStorage.removeItem(key)
  },
  valueOf () {
    return localStorage.valueOf()
  }
}
let localstorage = {
  install: function (vm) {
    vm.prototype.$local = store
  }
}
export default localstorage



// WEBPACK FOOTER //
// ./src/assets/js/localstorage.js